import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission, VenueType } from '../../generated/graphql';
import { OrdersIcon } from '../../ui-kit';
import { OrderDetailView, Orders } from '../../modules/orders';


const OrdersRoute: RouteType = {
    exact: true,
    path: routePaths.orders,
    title: translate('Orders'),
    icon: OrdersIcon,
    component: Orders,
    allowedVenueTypes: [VenueType.Restaurant],
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    },
    childrenRoutes: [
        {
            exact: true,
            title: translate('Order Details'),
            path: routePaths.ordersDetail,
            component: OrderDetailView,
        }
    ]
};

export default OrdersRoute;
